import { gsap } from 'gsap';

function breadcrumbsSetup(el) {
  const { children:items} = el.querySelector('.breadcrumbs__item');
  gsap.set(items, { autoAlpha: 0, x: -5, });
}

function breadcrumbsEnter(el) {
  const { children:items} = el.querySelector('.breadcrumbs__item');
  gsap.to(items, { autoAlpha: 1, x: 0, stagger: 0.05, ease: 'power2.out', duration: 1 });

}

export { breadcrumbsSetup, breadcrumbsEnter }